"use client"

import * as AccordionPrimitive from "@radix-ui/react-accordion"
import AccordionContent from "@/components/atoms/Accordion/accordion-content"
import AccordionTrigger from "@/components/atoms/Accordion/accordion-tirgger"
import * as React from "react"
import { cn } from '@/utils/index'

const AccordionItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Item ref={ref} className={cn("AccordionItem py-2", className)} {...props}>
    {children}
  </AccordionPrimitive.Item>
))
AccordionItem.displayName = "AccordionItem"

export { AccordionItem, AccordionTrigger, AccordionContent }
